export const AMOUNT_MIN_TO_USE_CREDIT = 63
export const CREDIT_CLARO_PAY = "credit-claro-pay"
export const ADVANCEMENT_CLARO_PAY = "advancement-claro-pay"
export const servicesIdTAE = [147,143,148,149, 146];
export const AMIGO_PAGUITOS = 247
export const MICROAPP = "MicroApp"
export const MINIAPP = "MiniApp"
export const TELMEX = 116
export const CFE = 83
export const DISH = 86
export const BLUE_TELECOM = 70
export const ATT = 148
export const SKY = 125
export const SKYPS = 112
export const AGUA_PUEBLA = 60
export const INFONAVIT = 92
export const MOVISTAR_POSTPAGO = 103
export const TELEVIA = 115
export const PASE = 107
export const MUEVECDMX = 284
export const NATURA = 241
export const AVON = 244
export const MEGACABLE_26_DIGITS = 101
export const TOTALPLAY = 123
export const NATURGY = 88
export const TELNOR = 120
export const TELCEL_IDS = [143,113,146];
export const OFFER_TELCEL_PAQUETE_AMIGO_SIN_LIMITE = 3
export const OFFER_TELCEL_PAQUETE_INTERNET_AMIGO = 2
export const OFFER_TELCEL_PAQUETE_POR_TIEMPO = 4
export const OFFER_TELCEL_RECARGA = 0
export const OFFER_TELCEL_POSPAGO = 1
export const OFFER_TELCEL_AMIGO_PAGUITOS = 5
export const OFFER_TELCEL_PAQUETE_POSPAGO_EVENTUAL = 6
export const OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN = 7
export const OFFER_TELCEL_PAQUETE_POSPAGO_MIXTO = 8
export const OFFER_TELCEL_PAQUETE_POR_TIEMPO_PLAN_MIXTO = 9
export const REDIRECT = 1
export const OPEN_NEW_MICROAPP = 2
export const BROWSE = 3
export const CHECK_BALANCE_N2_EVENT = "checkBalanceN2";
export const NAVIGATE = 4
export const CATEGORY_PLANS_ID_PAQUETE_AMIGO_SIN_LIMITE = 4
export const CATEGORY_PLANS_ID_PAQUETE_POR_TIEMPO = 8
export const CATEGORY_PLANS_ID_PAQUETE_INTERNET_AMIGO = 3
export const CATEGORY_PLANS_ID_RECARGA = 5
export const CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS = 23
export const CATEGORY_PLANS_ID_PAQUETE_MAS_DATOS_MIXTO = 33
export const CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO = 24
export const CATEGORY_PLANS_ID_PAQUETE_INTERNET_POSPAGO_MIXTO = 32
export const SERVICE_ID_TELCEL_RECARGA = 143
export const SERVICE_ID_TELCEL_POSPAGO = 113
export const SERVICE_ID_TELCEL_PAQUETES_POSPAGO = 254
export const SERVICE_ID_TELCEL_PAQUETES_MIXTOS = 285
export const SERVICE_ID_TELCEL_PLANES = 146
export const ARCUS_BILLER_IDS = [60,255,116,120,260,261,86,95,125,112,100,123,70,88,83,113,94,115,247]
export const BUNDLE_ID_CONTAINER_TELCEL = ["com.telcel.contenedor","com.telcel.contenedor.uat"]
export const AMOUNT_MAX_TO_USE_ADVANCEMENT = 100;
export const ACTION_COOKIE_SAVE = "saveck"
export const SCHEDULE_TELCEL_BILL_PAYMENT_PARAMS = {
    bank: "Banco Inbursa",
    periodicity: "Mensual",
    product: "Factura Telcel",
    providerService: "Radiomóvil Dipsa SA de CV"
}
export const MAX_AMOUNT_SERVICE_PAYMENT=23360
export const URL_APPLE_STORE = "https://apps.apple.com/mx/app/claro-pay/id1502765283"
export const URL_PLAY_STORE = "https://play.google.com/store/apps/details?id=com.globalhitss.claro.pay"
export const ADVANCEMENT_CARD_INFO = {
    value: ADVANCEMENT_CLARO_PAY,
    mark : "996",
    type :  0,
    lastDigits : " ",
    update: false
}
export const TELCEL_POSPAGO_MICROAPP_ID = "TelcelPospagoPS"
export const IDS_AVAILABLE_TO_SERVICE_BALANCE_TELCEL = [113]
export const TYPE_MODAL_BALANCE_CERO = "BALANCE_ZERO"
export const TYPE_MODAL_BALANCE_ERROR = "BALANCE_ERROR"
export const ARCUS_BILLER_IDS_TELCEL_CONTENEDOR = [60,255,116,120,260,261,86,95,125,112,100,123,70,88,83,113,94,115,247]

//Full Story
export const PAGO_SERVICIOS_SCANNER = "Scanner_Escaneo";
export const PAGO_SERVICIOS_PAY_METHOD = "PagoServicios_MetodoPago";
export const PAGO_SERVICIOS_CHECK_BALANCE = "PagoServicios_ConsultaSaldo"
export const PAGO_SERVICIOS_FORM_LOAD = "PagoServicios_Formulario"

export const VALUES_EVENT_DD_FULL_STORY  = [
    PAGO_SERVICIOS_SCANNER, 
    PAGO_SERVICIOS_PAY_METHOD,
    PAGO_SERVICIOS_CHECK_BALANCE,
    PAGO_SERVICIOS_FORM_LOAD
];

export const TIMER_SHOW_MSG_MODAL_IN_APP_LOGGED_USERS = 3000 * 60 //* 60 * 24
export const TIMER_SHOW_MSG_MODAL_IN_APP_ANONYMOUS_USERS = 3000 * 60 //* 60 * 24
